import clsx from 'clsx';
import { BLANK_IMAGE } from '@/annotation/ckEditorPlugins/components/RefreshingContent.molecule';
import type { ContentVisualizationProps } from '@/annotation/ckEditorPlugins/components/content.utilities';
import { Visualization } from '@/annotation/ckEditorPlugins/components/content.utilities.constants';
import { getAxiosInstance } from '@/requests/axios.utilities';
import { CONTENT_LOADING_CLASS, IMAGE_BORDER_CLASS } from '@/reportEditor/report.constants';
import { contentError } from '@/annotation/reportContent.utilities';
import { resizeContentToGridSize } from '@/dashboard/dashboard.utilities';
import { sqReportStore } from '@/core/core.stores';

export const ImageContent: React.FunctionComponent<ContentVisualizationProps> = ({
  contentId,
  noMargin,
  border,
  errorClass,
  extraClassNames,
  style,
  loading,
  target,
  src,
  onLoad,
  onError: _onError,
  onMeasurementsReady,
  showMenu,
  error,
  width = 0,
  height = 0,
  fromDashboard = false,
}) => {
  return (
    <img
      data-testid={`content-${contentId}`}
      data-seeq-content={contentId}
      data-visualization="image"
      style={style}
      ref={target}
      className={clsx(noMargin ? '' : 'p2', border ? IMAGE_BORDER_CLASS : '', extraClassNames, errorClass ?? '', {
        [CONTENT_LOADING_CLASS.SPINNER]: loading && !errorClass,
        [CONTENT_LOADING_CLASS.SPINNER_CORNER]: loading && !errorClass && src,
        [CONTENT_LOADING_CLASS.LOADED]: !loading && !errorClass,
      })}
      title={error}
      src={errorClass ? BLANK_IMAGE : src}
      onLoad={(ref) => {
        // Initial load will return a 1x1 empty image. Subsequent loads shouldn't.
        if (ref.currentTarget.naturalWidth !== 1 && ref.currentTarget.naturalHeight !== 1) {
          onLoad({ visualization: Visualization.NONE });
          // if it's an image let it take its own size
          onMeasurementsReady(0, 0);
          // TODO: CRAB-39312 once the backend manages the resize of the images this will be obsolete
          // if the actual image is a size other than what the content specifies we need to resize it
          if (
            fromDashboard &&
            (ref.currentTarget.naturalWidth !== width || ref.currentTarget.naturalHeight !== height)
          ) {
            return resizeContentToGridSize(sqReportStore.getContentById(contentId), width, height, false);
          }
        }
      }}
      onError={(e) => {
        const image = e.currentTarget;
        // re-try the request and get the error message to show more information in a tooltip
        getAxiosInstance()
          .get(e.currentTarget.src)
          .catch((error) => {
            contentError(contentId, error, error.status);
          });
        image.className = 'contentLoadError';
        image.src = BLANK_IMAGE;
      }}
      onClick={showMenu}
    />
  );
};
